import { IconDefinition, SizeProp as IconSizeProp } from '@fortawesome/fontawesome-svg-core';
import { PropsWithChildren } from 'react';
import { tv } from 'tailwind-variants';

import { Icon } from '@/components/ui/icon.component';

type BannerProps = PropsWithChildren<{
  icon: IconDefinition;
  iconSize?: IconSizeProp;
  variant?: 'alert' | 'info' | 'danger';
  className?: string;
}>;

const BannerStyles = tv({
  slots: {
    container: 'inline-flex items-center p-3 rounded-2xl border gap-3 shadow-tooltip',
    contentContainer: 'flex flex-col items-center gap-3 text-base',
    icon: '',
  },
  variants: {
    variant: {
      alert: {
        container: 'border-warning-300 bg-warning-100',
        contentContainer: 'text-warning-700',
        icon: 'text-warning-600',
      },
      info: {
        container: 'border-blue-300 bg-blue-100',
        contentContainer: 'text-blue-600',
        icon: 'text-blue-600',
      },
      danger: {
        container: 'bg-danger-100 border-danger-400',
        contentContainer: 'text-danger-700',
        icon: 'text-danger-600',
      },
    },
  },
  defaultVariants: {
    variant: 'alert',
  },
});

export default function Banner({ variant, icon, children, className, iconSize }: BannerProps) {
  const { container, contentContainer, icon: iconStyle } = BannerStyles({ variant });

  return (
    <div className={container()}>
      <Icon icon={icon} size={iconSize ?? 'xl'} className={iconStyle()} />
      <div className={contentContainer({ className })}>{children}</div>
    </div>
  );
}
